export default __webpack_public_path__ + "static/bg-color-7960bb721da9f44a1a8e65687820ee15.jpg";